import { FlowTypes } from '@interfaces/models/flow-types';
import { Store } from '@ngrx/store';
import { ContentPageId } from '@shared/models/content-page-ids';
import { OpenchoiceRemoteContent } from '@src/aem/models/OpenchoiceRemoteContent';
import { createSafeGetFactory } from '@src/aem/utils';
import { State } from '@store/index';
export const toPageContent = (remoteContent: OpenchoiceRemoteContent, store?: Store<State>) => {
  const item = remoteContent;
  const safeGetForRiskQuizResults = createSafeGetFactory(
    ContentPageId.openchoice,
    FlowTypes.MINOR,
    store,
  );
  const data = item?.data;
  return {
    continueButton: safeGetForRiskQuizResults(
      () => data?.nav_continueButton?.items[0]['labelText'],
      'continueButton',
    ),
  };
};
